<template>
  <div
    class="wt2-scrollable"
    @scroll.passive="emitScrollInfoNextTick"
    ref="wrapper"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bus: { type: Object, default: () => ({}) },
    useAnimation: { type: Boolean, default: true },
    // false - show only if some content is hidden
    showArrowsIfScrollable: { type: Boolean, default: false },
    animateSpeed: { type: Number, default: 500 },
  },

  data() {
    return {
      curAnimate: null,
      hasScroll: false,
    };
  },

  created() {
    // register EVENTS
    this.onEvent('SCROLLABLE_HORIZONTAL_RESET', this.resetScroll);
    this.onEvent('SCROLLABLE_HORIZONTAL_SCROLL_TO', this.scrollTo);
    this.onEvent('SCROLLABLE_HORIZONTAL_OFFSET_LEFT', this.offsetScrollLeft);
    this.onEvent('SCROLLABLE_HORIZONTAL_OFFSET_RIGHT', this.offsetScrollRight);
    this.onEvent('FORCE_UPDATE_SCROLL_INFO', this.emitScrollInfoNextTick);
    this.onEvent('SCROLL_PAGE_IF_NEEDED', this.$_onScrollPageIfNeeded);
  },

  mounted() {
    this.emitScrollInfo();
    window.addEventListener('resize', this.onResizeWindow);
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.onResizeWindow);
    this.offEvent('SCROLLABLE_HORIZONTAL_RESET', this.resetScroll);
    this.offEvent('SCROLLABLE_HORIZONTAL_SCROLL_TO', this.scrollTo);
    this.offEvent('SCROLLABLE_HORIZONTAL_OFFSET_LEFT', this.offsetScrollLeft);
    this.offEvent('SCROLLABLE_HORIZONTAL_OFFSET_RIGHT', this.offsetScrollRight);
    this.offEvent('FORCE_UPDATE_SCROLL_INFO', this.emitScrollInfoNextTick);
    this.offEvent('SCROLL_PAGE_IF_NEEDED', this.$_onScrollPageIfNeeded);
    this.cancelAnimate();
  },

  methods: {
    hasRef(cb) {
      if (this.$refs && this.$refs.wrapper) {
        cb(this.$refs.wrapper);
      }
    },

    emitScrollInfo() {
      this.hasRef((ref) => {
        this.hasScroll = ref.scrollWidth > ref.clientWidth;
        if (this.showArrowsIfScrollable) {
          this.$emit('update:hasLeft', this.hasScroll);
          this.$emit('update:hasRight', this.hasScroll);
        } else {
          this.$emit('update:hasLeft', ref.scrollLeft > 0);
          this.$emit(
            'update:hasRight',
            ref.scrollWidth > ref.scrollLeft + ref.offsetWidth
          );
        }
      });
    },

    animate(fn, distance) {
      this.cancelAnimate();
      let start;
      let lastInterval = 0;

      const animationStep = (timestamp) => {
        if (!start) {
          start = timestamp;
        }

        const progress = timestamp - start;

        if (progress < this.animateSpeed) {
          const interval = distance / (this.animateSpeed / progress);
          interval && fn(interval - lastInterval);
          lastInterval = interval;
          this.curAnimate = requestAnimationFrame(animationStep);
        }
      };

      this.curAnimate = requestAnimationFrame(animationStep);
    },

    cancelAnimate() {
      cancelAnimationFrame(this.curAnimate);
      this.curAnimate = null;
    },

    offsetScrollLeft() {
      this.offsetScroll(true);
    },

    offsetScrollRight() {
      this.offsetScroll(false);
    },

    offsetScroll(isDirectionLeft, offsetNumber) {
      this.hasRef((ref) => {
        const distance = _.isNumber(offsetNumber)
          ? offsetNumber
          : ref.scrollWidth - ref.scrollLeft > ref.offsetWidth
          ? ref.offsetWidth
          : ref.scrollWidth - ref.scrollLeft;

        const fn = isDirectionLeft
          ? this.offsetLeft.bind(this, ref)
          : this.offsetRight.bind(this, ref);

        this.useAnimation ? this.animate(fn, distance) : fn(distance);

        this.emitScrollInfoNextTick();
      });
    },

    offsetRight(ref, scrollDistance) {
      ref.scrollLeft += scrollDistance;
    },

    offsetLeft(ref, scrollDistance) {
      ref.scrollLeft -= scrollDistance;
    },

    scrollTo(pos) {
      this.hasRef((ref) => {
        this.cancelAnimate();
        ref.scrollLeft = pos;
        this.emitScrollInfoNextTick();
      });
    },

    $_onScrollPageIfNeeded({ $el }) {
      this.hasRef((ref) => {});
    },

    resetScroll() {
      this.hasRef((ref) => {
        this.cancelAnimate();
        ref.scrollLeft = 0;
        this.emitScrollInfoNextTick();
      });
    },

    emitScrollInfoNextTick() {
      this.$nextTick(() => {
        this.emitScrollInfo();
      });
    },

    onResizeWindow(e) {
      e.preventDefault();
      this.emitScrollInfoNextTick();
    },

    offEvent(eventName, callback) {
      _.isObject(this.bus) &&
        _.isFunction(this.bus.$on) &&
        this.bus.$off(eventName, callback);
    },

    onEvent(eventName, callback) {
      _.isObject(this.bus) &&
        _.isFunction(this.bus.$on) &&
        this.bus.$on(eventName, callback);
    },
  },
};
</script>
